import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';

@Component({
    templateUrl: 'message-box-image-dialog.component.html'
})
export class MessageBoxImageDialogComponent {

    public image: string;
    public translations: { [key: string]: string } = { 'CLOSE': 'Fermer'};

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.image = data.image;
        this.translations = data.translations;
    }

}
